export const malaysiaMyKadValidator = (taxId: string, dateOfBirth: string, value: string | number | boolean) => {
  const dobWithoutDashes = dateOfBirth.replaceAll('-', '').substr(-6);
  const isValid = dobWithoutDashes === taxId.substring(0, 6);
  if (isValid)
    return null;
  return 'taxValidationWarningMessage';
      
  };
